module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-7.8a324432.jpg";